
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.88 20.417v-3.152C3.493 17.037 0 13.395 0 8.956 0 4.368 3.73.64 8.318.64c4.587 0 8.317 3.73 8.317 8.317 0 4.334-3.012 8.694-7.503 10.857l-1.252.604zM8.318 2.39A6.569 6.569 0 001.75 8.956a6.569 6.569 0 006.567 6.567H9.63v2.013c3.187-2.013 5.253-5.323 5.253-8.58A6.569 6.569 0 008.318 2.39zm-.876 10.068h1.751v1.751h-1.75v-1.75zm1.751-1.313h-1.75c0-2.845 2.626-2.627 2.626-4.378 0-.963-.788-1.75-1.751-1.75-.963 0-1.751.787-1.751 1.75H4.815a3.501 3.501 0 013.503-3.502 3.501 3.501 0 013.502 3.502c0 2.19-2.627 2.408-2.627 4.378z","fill":"#000"}})])
          )
        }
      }
    